import { animate, group, style, transition, trigger } from '@angular/animations';

export const rowTransitionAnimation = trigger('rowTransitionAnimation', [
	transition(':enter', [
		style({ opacity: 0, transform: 'translateY(10px)' }),
		animate('{{ delay }}ms 50ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
	], { params: { delay: 200 } }),

	transition(':leave', [
		group([
			animate('250ms ease-in', style({ opacity: 0 })),
			animate('300ms ease-in', style({ height: 0, margin: 0, padding: 0 }))
		])
	])
]);
